import { render, staticRenderFns } from "./MarketDemand.vue?vue&type=template&id=ecbe9ff8&"
import script from "./MarketDemand.vue?vue&type=script&lang=js&"
export * from "./MarketDemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports